import { render, staticRenderFns } from "./RoleBindings.vue?vue&type=template&id=bb034c52&scoped=true&"
import script from "./RoleBindings.vue?vue&type=script&lang=js&"
export * from "./RoleBindings.vue?vue&type=script&lang=js&"
import style0 from "./RoleBindings.vue?vue&type=style&index=0&id=bb034c52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb034c52",
  null
  
)

export default component.exports